<!-- Body Type Add/Edit Modal -->
<div class="modal fade" id="kt_modal_body_type_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content" style="overflow: visible;">
      <div class="modal-header" id="kt_modal_body_type_add_edit_header">
        <h2 class="fw-bold">{{ isEditMode ? 'Edit Body Type' : 'Add Body Type' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body px-5 my-7" style="overflow: visible;">
        <form [formGroup]="bodyTypeForm" (ngSubmit)="onSubmit()">
          <div class="d-flex flex-column px-5 px-lg-10" style="overflow: visible;">

            <!-- Name -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Name</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="name"
                  placeholder="Enter body type name"
                  [class.is-invalid]="name?.invalid && name?.touched"
                />
                <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                  <div *ngIf="name?.errors?.['required']">Body type name is required</div>
                  <div *ngIf="name?.errors?.['minlength']">Body type name must be at least 2 characters</div>
                </div>
              </div>
            </div>

            <!-- Type -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Type</label>
                <select
                  class="form-select form-select-solid"
                  formControlName="type"
                  [class.is-invalid]="type?.invalid && type?.touched"
                >
                  <option value="">Select vehicle type</option>
                  <option *ngFor="let vehicleType of vehicleTypes" [value]="vehicleType._id || vehicleType.id">
                    {{ vehicleType.name }}
                  </option>
                </select>
                <div *ngIf="type?.invalid && type?.touched" class="invalid-feedback">
                  <div *ngIf="type?.errors?.['required']">Vehicle type is required</div>
                </div>
                <div *ngIf="isLoadingVehicleTypes" class="text-muted mt-2">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading vehicle types...
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>

      <div class="modal-footer flex-center">
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isLoading || bodyTypeForm.invalid"
          (click)="onSubmit()"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm align-middle me-2"></span>
          {{ isEditMode ? 'Update Body Type' : 'Add Body Type' }}
        </button>
      </div>
    </div>
  </div>
</div>
